import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/core/services/jwt.service";

/**
 * Service to call HTTP request via Axios
 */

const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    // const hostname = window.location.hostname
    //Vue.axios.defaults.baseURL = hostname.includes("192.168.1.15") ? 'http://192.168.1.15:3000/api/v1/': "https://agricactus-api.herokuapp.com/api/v1/";

    /* if(hostname.includes("192.168.1.15")){
      Vue.axios.defaults.baseURL = '//192.168.1.15:3000/api/v1/'
    }else if(hostname.includes("localhost") || hostname.includes("127.0.0.1")){
      Vue.axios.defaults.baseURL = '//187.188.37.201:3000/api/v1/'  // "https://agricactus-api.herokuapp.com/api/v1/" 
    }else{
      Vue.axios.defaults.baseURL = '//187.188.37.201:3000/api/v1/'
    } */
    /*  if(hostname.includes("localhost")){
      Vue.axios.defaults.baseURL = 'http://localhost:3000/api/v1/'
   }else{ */
    Vue.axios.defaults.baseURL = "https://api.appagricactus.com";
    // }
  },

  /**
   * Set the default HTTP request headers
   */

  setHeader() {
    Vue.axios.defaults.headers.common["token"] = `${JwtService.getToken()}`;
  },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch(error => {
      // console.log(error);
      throw new Error(`[KT] ApiService ${error}`);
    });
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */

  get(resource, slug = "") {
    return Vue.axios.get(`${resource}/${slug}`).catch(error => {
      // console.log(error);
      throw new Error(`[KT] ApiService ${error}`);
    });
  },

  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  post(resource, params) {
    return Vue.axios.post(`${resource}`, params);
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */

  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params);
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  put(resource, params) {
    return Vue.axios.put(`${resource}`, params);
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */

  delete(resource) {
    return Vue.axios.delete(resource).catch(error => {
      // console.log(error);
      throw new Error(`[RWV] ApiService ${error}`);
    });
  }
};

export default ApiService;
